import axj_web_action from './axj-web/actions'
import common_action from './common/actions'
import axj_help_action from './axj_help/actions'
export default{
  ...axj_web_action,
  ...common_action,
  ...axj_help_action
}



// WEBPACK FOOTER //
// ./src/store/actions.js